import { motion } from "framer-motion";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import { Image } from "@/components/ui/image";
// ✅ Import de la imagen local
import propiedadImage from "@/assets/images/propiedad/la-propiedad.png";

const FEATURES = [
  { title: "Arquitectura Orgánica", desc: "Diseño que se integra al paisaje natural" },
  { title: "Vistas Panorámicas", desc: "Lago y montaña desde cada espacio" },
  { title: "Materiales Nobles", desc: "Piedra, madera y elementos locales" },
];

export default function LaPropiedad() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="propiedad" ref={ref} className="py-28 md:py-40 px-6 lg:px-10 bg-secondary/30">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          animate={isVisible ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 1.2 }}
          className="relative aspect-[4/5] overflow-hidden order-2 lg:order-1"
        >
          <Image
            src={propiedadImage}
            alt="La Propiedad"
            className="w-full h-full"
            fittingType="fill"
          />
        </motion.div>

        {/* Content */}
        <div className="order-1 lg:order-2">
          <motion.span
            initial={{ opacity: 0 }}
            animate={isVisible ? { opacity: 1 } : {}}
            transition={{ duration: 1 }}
            className="text-accent text-sm tracking-[0.3em] uppercase font-light mb-6 block"
          >
            La Propiedad
          </motion.span>

          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.1 }}
            className="font-serif-display text-4xl md:text-5xl font-light text-foreground text-balance leading-tight mb-8"
          >
            Un espacio diseñado para el descanso
          </motion.h2>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={isVisible ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 1.2, delay: 0.2 }}
            className="text-foreground/70 font-light text-lg leading-relaxed mb-10"
          >
            La casa cuenta con amplios espacios interiores bañados de luz natural,
            terrazas con vistas espectaculares y áreas comunes diseñadas para
            compartir momentos inolvidables. Cada habitación es un santuario privado.
          </motion.p>

          <div className="space-y-6">
            {FEATURES.map((feature, i) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, y: 20 }}
                animate={isVisible ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 1, delay: 0.3 + i * 0.1 }}
                className="flex items-start gap-4 pb-6 border-b border-border"
              >
                <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center flex-shrink-0">
                  <div className="w-2 h-2 rounded-full bg-accent" />
                </div>
                <div>
                  <h3 className="font-serif-display text-lg text-foreground mb-1">{feature.title}</h3>
                  <p className="text-sm text-muted-foreground font-light">{feature.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}